import { getId } from './helpers';

// Each location is paired with its own workers' comp code. Pairings only carry `locationId`, so
// names / addresses / states come from the populated `locations` (see useMissingPairingLocations
// for pairings whose location the read did not populate). Codes are read-only once added: to
// change one, remove the pairing and add the location again.
export const PAIRINGS_FIELD = 'locationAndWorkersCompPairings';

export const ADD_PAIRING_ROUTE = 'position-templates/add-location-and-workers-comp';
export const REMOVE_PAIRING_ROUTE = 'position-templates/remove-location-and-workers-comp';

export const getPairings = (positionTemplate) => positionTemplate?.[PAIRINGS_FIELD] || [];

export const getPairedLocationIds = (positionTemplate) =>
  getPairings(positionTemplate).map((pairing) => pairing.locationId);

export const getPairingRows = (positionTemplate) => {
  const locationsById = new Map(
    (positionTemplate?.locations || []).map((location) => [getId(location), location])
  );
  return getPairings(positionTemplate).map((pairing) => ({
    pairingId: getId(pairing),
    locationId: pairing.locationId,
    location: locationsById.get(pairing.locationId),
    workersCompCode: pairing.workersCompCode || '',
  }));
};

export const getPairedLocations = (positionTemplate) =>
  getPairingRows(positionTemplate)
    .map((row) => row.location)
    .filter(Boolean);

const syncPairingsFromResponse = (document) =>
  document?.[PAIRINGS_FIELD] ? { [PAIRINGS_FIELD]: document[PAIRINGS_FIELD] } : undefined;

export const buildAddPairingSave = (positionTemplate, { location, workersCompCode }) => {
  const locationId = getId(location);
  const locations = positionTemplate.locations || [];
  return {
    patch: {
      [PAIRINGS_FIELD]: [...getPairings(positionTemplate), { locationId, workersCompCode }],
      ...(!locations.some((l) => getId(l) === locationId) && {
        locations: [...locations, location],
      }),
    },
    request: {
      httpMethod: 'POST',
      route: ADD_PAIRING_ROUTE,
      data: { positionTemplateId: getId(positionTemplate), locationId, workersCompCode },
    },
    fromResponse: syncPairingsFromResponse,
  };
};

export const buildRemovePairingSave = (positionTemplate, pairingId) => ({
  patch: {
    [PAIRINGS_FIELD]: getPairings(positionTemplate).filter(
      (pairing) => getId(pairing) !== pairingId
    ),
  },
  request: {
    httpMethod: 'POST',
    route: REMOVE_PAIRING_ROUTE,
    data: { pairingId },
  },
  fromResponse: syncPairingsFromResponse,
});
